import { AToastNotificationDispatcher } from 'core_a-toast-notification';

export default ({ app, store }, inject) => {
  inject('toastNotification', AToastNotificationDispatcher);
};
